import React from 'react'
import { FormatMoney } from 'Utils/functions'
import { PAYMENT_NAMES } from 'Views/OrdenDeVenta/constants'
import {
  getCreditCardLastFourDigits,
  getPaymentLabel,
  getPaymentType,
  getYappyConfirmationNumber,
} from 'Views/OrdenDeVenta/utils/paymentTypesValidation'

export function PaymentTypeItem({ payment }) {
  const { isCreditCard, isCreditAccount, isCmf, isYappy } =
    getPaymentType(payment)
  const coincidence = Object.keys(PAYMENT_NAMES).find(key =>
    payment?.PaymentName?.toLowerCase()?.includes(key)
  )
  const lastFourDigits = getCreditCardLastFourDigits(
    payment,
    isCreditCard,
    isCmf
  )

  const paymentLabel = getPaymentLabel(
    payment,
    isCmf,
    isCreditCard,
    isCreditAccount,
    lastFourDigits
  )

  return (
    <p style={{ fontSize: '14px' }} data-testid="label-payment-type-item">
      {PAYMENT_NAMES[coincidence] || 'Otro:'}
      {paymentLabel}
      {FormatMoney(payment?.PaymentAmount || 0, true, 2, true)}
      {isYappy &&
        ` - Confirmation Number: ${getYappyConfirmationNumber(payment)}`}
    </p>
  )
}
